import {required} from "vuelidate/lib/validators";  
const ODuyuru = {
    data() {
      return { 
        ODuyuruData:{  
          Baslik:"",
          Icerik:"",
          IslemTarihi:"", 
          KayitTarihi:"",  
          YeniMi:false,  
          KimeGorunur:"", 
          KaydedenPersonelId:"3fa85f64-5717-4562-b3fc-2c963f66afa6",  
          Deleted:false,
        },  
          FormDataType:{
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:this.$t('ODuyuru.AddEdit.Baslik'),FieldType:"text"},
            Icerik:{FieldName:"Icerik",Field:"textarea",FieldTitle:this.$t('ODuyuru.AddEdit.Icerik')},
            IslemTarihi:{FieldName:"IslemTarihi",Field:"date",FieldTitle:this.$t('ODuyuru.AddEdit.IslemTarihi')}, 
            YeniMi:{FieldName:"YeniMi",Field:"checkbox",FieldTitle:this.$t('ODuyuru.AddEdit.YeniMi')}  
          }  
      } 
    },
    validations:{ 
      FormData: {
          Baslik: { required },  
          Icerik: { required }, 
          IslemTarihi: { required }, 
          YeniMi: {  },  
      } 
  },
}
export default ODuyuru